export interface IRoleBasedTableRoleSettings {
  role: string
  columns: string[]
}

export interface IRoleBasedTableSettings {
  forRoles: IRoleBasedTableRoleSettings[]
}

export type RoleDefaultColumns = Record<string, string[]>

export const EMPTY_ROLE_DEFAULT_COLUMNS: RoleDefaultColumns = {}

export const DEFAULT_ROLE_KEY = 'default-role'

export const createRoleSettings = (
  role: string,
  columns: string[],
): IRoleBasedTableRoleSettings => {
  return { role, columns: [...columns] }
}

export const getDefaultSettings = (
  defaultColumns: string[],
  defaultRoleKey: string = DEFAULT_ROLE_KEY,
  roleDefaultColumns: RoleDefaultColumns = EMPTY_ROLE_DEFAULT_COLUMNS,
): IRoleBasedTableSettings => {
  return {
    forRoles: [
      createRoleSettings(defaultRoleKey, defaultColumns),
      ...Object.entries(roleDefaultColumns)
        .filter(([role]) => role !== defaultRoleKey)
        .map(([role, columns]) => createRoleSettings(role, columns)),
    ],
  }
}

export const parseRoleBasedTableSettings = ({
  value,
  settingKey,
  defaultColumns,
  defaultRoleKey = DEFAULT_ROLE_KEY,
  roleDefaultColumns = EMPTY_ROLE_DEFAULT_COLUMNS,
}: {
  value?: string
  settingKey: string
  defaultColumns: string[]
  defaultRoleKey?: string
  roleDefaultColumns?: RoleDefaultColumns
}): IRoleBasedTableSettings => {
  try {
    return value
      ? JSON.parse(value)
      : getDefaultSettings(defaultColumns, defaultRoleKey, roleDefaultColumns)
  } catch {
    console.warn(`cant parse settings ${settingKey}`)
    return getDefaultSettings(defaultColumns, defaultRoleKey, roleDefaultColumns)
  }
}
